import { httpApi } from '@app/api/http.api';
import { IDealRoomPeople, IDealRoomPeopleTime, IDealRoomPeopleUrl } from '@app/interfaces/deal-room-people';
import { SearchQueryRequest, SearchQueryResponse } from '@app/interfaces/interfaces';
import * as http from 'http';

const baseSlug = 'deal-room-people';

export const getDealRoomPeoples = async (dealRoomId: string): Promise<IDealRoomPeople[]> => {
  try {
    const { data } = await httpApi.get<IDealRoomPeople[]>(`/${baseSlug}/list/${dealRoomId}`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const getDealRoomPeopleShortLink = async (
  dealRoomId: string,
): Promise<{
  shortUrl: string;
}> => {
  try {
    const { data } = await httpApi.get<{ shortUrl: string }>(`/${baseSlug}/shortUrl/${dealRoomId}`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const getDealRoomPeopleSharableUrl = async (
  dealRoomId: string,
  payload: IDealRoomPeopleUrl,
): Promise<{
  shortUrl: string;
}> => {
  try {
    const { data } = await httpApi.post<{ shortUrl: string }>(`/${baseSlug}/shortUrl/${dealRoomId}`, payload);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const createDealRoomPeople = async (payload: Partial<IDealRoomPeople>): Promise<IDealRoomPeople> => {
  try {
    const { data } = await httpApi.post<IDealRoomPeople>(`/${baseSlug}`, payload);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const deleteDealRoomPeople = async (id: string): Promise<undefined> => {
  try {
    const { data } = await httpApi.delete<undefined>(`/${baseSlug}/${id}`);
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const updateDealRoomPeopleTime = async (
  id: string,
  payload: Partial<IDealRoomPeopleTime>,
): Promise<undefined> => {
  try {
    const { data } = await httpApi.post<undefined>(`/${baseSlug}/time/${id}`, payload, {
      httpAgent: new http.Agent({ keepAlive: true }),
    });
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};

export const getDealRoomPeopleListWithPagination = async (
  dealRoomId: string,
  queryPayload: SearchQueryRequest,
): Promise<SearchQueryResponse> => {
  try {
    const { data } = await httpApi.get<SearchQueryResponse>(
      `${baseSlug}/queryDealRoomPeople/${dealRoomId}?${new URLSearchParams(
        queryPayload as Record<string, string>,
      ).toString()}`,
    );
    return data;
  } catch (error) {
    return await Promise.reject(error);
  }
};
